module.exports = __webpack_public_path__ + "static/dcc031fd03a989773f53df1e06d25b83f1c436b3448b718de59023b4f91fa45a-a911839d4bb675930e22aaaa050d00af.jpeg";